// extracted by mini-css-extract-plugin
export default {"checkoutWrapper":"lUz52I"};